import { useState, useEffect } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './StatsCounter.css';

interface Stat {
  value: number;
  label: string;
  suffix?: string;
  prefix?: string;
}

const STATS: Stat[] = [
  { value: 500, label: 'Hectares Monitorizados', suffix: '+' },
  { value: 150, label: 'Agricultores Satisfeitos', suffix: '+' },
  { value: 30, label: 'Economia de Água', suffix: '%' },
  { value: 99, label: 'Disponibilidade', suffix: '%' }
];

const StatsCounter = () => {
  const { elementRef, isVisible } = useScrollReveal({ threshold: 0.3 });
  const [counts, setCounts] = useState<number[]>(STATS.map(() => 0));

  useEffect(() => {
    if (!isVisible) return;

    const duration = 2000;
    const steps = 60;
    const stepDuration = duration / steps;
    const timers: NodeJS.Timeout[] = [];

    STATS.forEach((stat, index) => {
      let currentStep = 0;
      const increment = stat.value / steps;

      const timer = setInterval(() => {
        currentStep++;
        setCounts(prevCounts => {
          const newCounts = [...prevCounts];
          newCounts[index] = Math.min(
            Math.round(increment * currentStep),
            stat.value
          );
          return newCounts;
        });

        if (currentStep >= steps) {
          clearInterval(timer);
        }
      }, stepDuration);

      timers.push(timer);
    });

    return () => {
      timers.forEach(timer => clearInterval(timer));
    };
  }, [isVisible]);

  return (
    <section className="stats-section" ref={elementRef}>
      <div className="container">
        <div className="stats-grid">
          {STATS.map((stat, index) => (
            <div key={index} className="stat-item">
              <div className="stat-value">
                {stat.prefix}
                {counts[index]}
                {stat.suffix}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsCounter;
